
import * as defaultImport from "@splunk/react-icons/enterprise/ChartPie";
export * from "@splunk/react-icons/enterprise/ChartPie";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
